/**
 * Logger utility for UTMS Frontend.
 * Ensures that console logs are only output in development mode to prevent
 * clutter and potential information leaks in production.
 */

const isProduction = process.env.NODE_ENV === 'production';

export const logger = {
  log: (...args) => {
    if (!isProduction) {
      console.log(...args);
    }
  },
  warn: (...args) => {
    if (!isProduction) {
      console.warn(...args);
    }
  },
  error: (...args) => {
    // Errors might still be useful in production, but we could wrap this 
    // with an external monitoring service like Sentry in the future.
    console.error(...args);
  },
  info: (...args) => {
    if (!isProduction) {
      console.info(...args);
    }
  },
  debug: (...args) => {
    if (!isProduction) {
      console.debug(...args);
    }
  }
};

export default logger;
